/** Espelha public.tipo_destinatario_notificacao (db_compras) e `TipoDestinatarioNotificacaoEnum` da API Compras. */
export enum TipoDestinatarioNotificacaoEnum {
  Responsavel = 1,
  Solicitante = 2,
  Perfil = 3,
  Usuario = 4,
}
